import type {TrackingManagerV1} from '@volkswagen-onehub/tracking-service';

import {version} from '../../package.json';
import {getSelectedValue} from '../components/TrimFilter';

const TRIM_FILTER_VARS = {
  type: 'single_value',
  name: 'Trim Selection',
};

type ToggleAccordionClickProps = {
  open: boolean;
  name: string;
  position: number;
  count: number;
  changedAutomatically?: boolean;
};

export class TrackingService {
  constructor(private readonly trackingService: TrackingManagerV1) {}

  track(eventName: string, data: Record<string, unknown> = {}): void {
    this.trackingService &&
      this.trackingService.track(eventName, {
        ...data,
        // remove when setting version has been automized
        environment: {featureAppIdAppVersion: version},
      });
  }

  trackLayerLoad(): void {
    const event = 'VWBasic_Layer_Load';
    this.track(event);
  }

  trackLayerClose(): void {
    const event = 'VWBasic_LayerClose_Click';
    this.track(event);
  }

  trackToggleAccordionClick(props: ToggleAccordionClickProps): void {
    const {open, name, position, count, changedAutomatically = false} = props;
    const event = open
      ? 'VWBasic_AccordionOpen_Click'
      : 'VWBasic_AccordionClose_Click';

    let trimFilter;
    const trimFilterValue = getSelectedValue();
    if (trimFilterValue) {
      trimFilter = {
        ...TRIM_FILTER_VARS,
        values: [trimFilterValue],
      };
    }

    this.track(event, {
      accordion: {
        groupItemName: name,
        groupItemState:
          (open ? 'opened' : 'closed') +
          (changedAutomatically ? ' automatically' : ' by click'),
      },
      link: {
        name: name,
      },
      content: {
        ItemCount: count,
        ItemPosition: position,
      },
      filter: trimFilter,
    });
  }

  trackSubNavigationClick(linkName: string, tabName: string): void {
    const event = 'VWBasic_SubNavigation_Click';
    this.track(event, {
      tab: {
        name: tabName,
      },
      link: {
        name: linkName,
      },
    });
  }

  trackContentTabClick(linkName: string, tabName: string): void {
    const event = 'VWBasic_ContentTab_Click';
    this.track(event, {
      tab: {
        name: tabName,
      },
      link: {
        name: linkName,
      },
    });
  }

  trackTrimFilterClick(values: string[]): void {
    const event = 'VWBasic_FilterSelect_Click';
    this.track(event, {
      filter: {
        ...TRIM_FILTER_VARS,
        values,
      },
    });
  }
}
